import LoadingBar from 'components/LoadingBar'
import { kFormat } from 'container/Projects/LiveProjects/Project/IdeaLab/utils'
import { getDifficultyLabel } from 'utils/functions/IdeaLab/getDifficultyLabel'

import s from './Header.module.css'

type Props = {
  label: string
  isLoading: boolean
  difficulty?: number
  volume?: number
}

export const Header = ({ label, volume, difficulty, isLoading }: Props) => {
  return (
    <div className={s.wrapper}>
      <div className={s.titleWrapper}>
        <div className={s.title}>{label}</div>
      </div>
      <div className={s.details}>
        <div className={s.detail}>
          Total Monthly Volume:
          <div className={s.volume}>
            {isLoading && <LoadingBar width={30} borderRadius={20} />}
            {!isLoading && volume && `${kFormat(volume)}`}
          </div>
        </div>
        <div className={s.detail}>
          Difficulty:
          {isLoading && <LoadingBar width={50} borderRadius={20} />}
          {!isLoading && difficulty && (
            <>
              <div className={s.difficulty}>{`${difficulty}%`}</div>
              <div className={s.difficultyCategory}>
                {getDifficultyLabel(difficulty)}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
